import { DataHeader, DataSource, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutMobileCommReeferProfile extends Layout {
    dataheaderMobileCommReefer: DataHeader;
    panelMobileCommReefer: Panel;
    sourceMCReeferProfile: DataSource;
    textboxDescription: Textbox;
    textboxId: Textbox;
    textboxType: Textbox;
}
